import {
  SET_GYM_DATA,
  SET_GYM_ATTRIBUTE,
  SET_SCANNER_CHECKIN_TOKEN,
  SET_EXPIRING_TODAY_POP_OPEN,
  SET_EXPIRING_TODAY_DATA,
  SET_MEMBER_AT_RISK,
  SET_STATS,
} from "../../actions/types/types";

const initState = {
  gym: {},
  gymAttribute: [],
  loading: false,
  checkinPopupOpen: false,
  scannerCheckinToken: undefined,
  expiringTodayPopupOpen: false,
  expiringTodayMemberships: undefined,
  memberAtRisk: [],
  dashboardStats: {},
  memberLoading: false,
  categories: [],
  gymConfig: {},
};

const GymReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_GYM_DATA:
      return {
        ...state,
        gym: action.payload.data,
        gymConfig: action.payload.data?.configData && action.payload.data.configData.config && action.payload.data.configData.config.features, 
      };
    case SET_GYM_ATTRIBUTE:
      return {
        ...state,
        gymAttribute: action.payload.data,
      };
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload.data,
      };
    case "SET_GYM_CATEGORIES":
      return {
        ...state,
        categories: action.payload.data,
      };

    case "SET_MEMBER_LOADING":
      return {
        ...state,
        memberLoading: action.payload.data,
      };

    case "SET_CHECKIN_POP_OPEN":
      return {
        ...state,
        checkinPopupOpen: action.payload.data,
      };
    case SET_SCANNER_CHECKIN_TOKEN:
      return {
        ...state,
        scannerCheckinToken: action.payload.data,
      };
    case SET_EXPIRING_TODAY_POP_OPEN:
      return {
        ...state,
        expiringTodayPopupOpen: action.payload.data,
      };
    case SET_EXPIRING_TODAY_DATA:
      return {
        ...state,
        expiringTodayMemberships: action.payload.data,
      };
    case SET_MEMBER_AT_RISK:
      return {
        ...state,
        memberAtRisk: action.payload.data,
      };
    case SET_STATS:
      return {
        ...state,
        dashboardStats: action.payload.data,
      };
    default:
      return { ...state };
  }
};

export default GymReducer;
